import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Invoices from './Invoices'

function App() {
  return (
    <Router>
      <Routes>
        {/* <Invoices /> */}
        <Route
          path="/"
          element={<Invoices />}
        />
      </Routes>
    </Router>
  );
}
export default App;
